// extracted by mini-css-extract-plugin
module.exports = {"loader":"TokenList_loader__AvF4g","add":"TokenList_add__sKs7J"};